import SmartListItem from '../SmartList/SmartListItem.vue';

export default SmartListItem;
